module.exports = __webpack_public_path__ + "static/trade-only-1d496c1f30c94dbd33625f74ded913a3.png";